import React from "react";
import styled from "@emotion/styled";
import { NewLabel } from "../../../../../StyledComponents";

const TreeItem = ({ borrower, selectReport, reportId, selectedReportId, date, itemIndex, isNew, address }) => {
  
  return (
    <>
      {selectedReportId === reportId && isNew ?
        <TreeItemContainer new selected onClick={() => selectReport(reportId)}>
          <NewLabel className="reportTree">New</NewLabel>
          <div style={{width: 'fit-content', padding: '0', gridColumn: '4', margin: '0 auto'}}>
            {itemIndex + 1} 
          </div>
          <TreeItemWrapper selected new >
            <span>{date}</span>
            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
              <span>{borrower}</span>
              <span>{address}</span>
            </div>
          </TreeItemWrapper>
        </TreeItemContainer>
      : selectedReportId === reportId ?
        <TreeItemContainer selected onClick={() => selectReport(reportId)}>
          <div style={{width: 'fit-content', padding: '0', gridColumn: '2', margin: '0 auto'}}>
            {itemIndex + 1} 
          </div>
          <TreeItemWrapper selected >
            <span>{date}</span>
            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
              <span>{borrower}</span>
              <span>{address}</span>
            </div>
          </TreeItemWrapper>
        </TreeItemContainer>
      : isNew ?
        <TreeItemContainer new onClick={() => selectReport(reportId)}>
          <NewLabel className="reportTree">New</NewLabel>
          <div style={{width: 'fit-content', padding: '0', gridColumn: '4', margin: '0 auto'}}>
            {itemIndex + 1} 
          </div>
          <TreeItemWrapper new >
            <span>{date}</span>
            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
              <span>{borrower}</span>
              <span>{address}</span>
            </div>
          </TreeItemWrapper>
        </TreeItemContainer>
      :
        <TreeItemContainer onClick={() => selectReport(reportId)}>
          <div style={{width: 'fit-content', padding: '0', gridColumn: '2', margin: '0 auto'}}>
            {itemIndex + 1} 
          </div>
          <TreeItemWrapper>
            <span>{date}</span>
            <div style={{display: 'flex', flexDirection: 'column', width: '100%'}}>
              <span>{borrower}</span>
              <span>{address}</span>
            </div>
          </TreeItemWrapper>
        </TreeItemContainer>
      }
    </>
  )
}

const TreeItemWrapper = styled.div`
  grid-column: ${(props) => props.new ? '6' : '4'};
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border: ${(props) => props.selected ? '0.1rem solid #01538F' : '0.1rem solid #E3E5EB'};
  border-radius: 0.45rem;
  padding: 0.7rem 0.65rem;
  color: ${(props) => props.selected ? '#1C1C1F' : '#666C78'};
  background: ${(props) => props.selected ? '#ffffff' : '#F8FAFC'};
  text-align: left;

  > span {
    flex: 0 0 auto;
    min-width: 6rem;
    color: #939599;
    font-size: 0.8rem;
    font-weight: 800;
  }

  div span:first-of-type {
    color: #1C1C1F;
    font-size: 0.9rem;
    font-weight: 800;
  }

  div span:last-of-type {
    color: #666C78;
    font-size: 0.78rem;
    font-weight: 600;
  }
`
const TreeItemContainer = styled.button`
  height: fit-content;
  width: 100%;
  display: grid;
  grid-template-columns: ${(props) => props.new ? '0.5rem 3rem 0.5rem 3rem 0.5rem minmax(0, 1fr) 0.5rem' : '4rem 3rem 0.5rem minmax(0, 1fr) 0.5rem'};
  justify-content: center;
  align-items: center;
  padding: 0.35rem 0;
  border-bottom: 0.05rem solid #EAECF2;
  border-top: none;
  border-left: none;
  border-right: none;
  background-color: ${(props) => props.selected ? `#E8F1FA` : `#ffffff`};
  color: #666C78;

  &:hover {
    cursor: ${(props) => props.selected ? 'default' : 'pointer'};
    background-color: ${(props) => props.selected ? '#E8F1FA' : '#F7F7F7'};
  }
`

export default TreeItem;
